import React from 'react';
import { FormattedMessage } from 'react-intl';
import './mobileInfinityLoading.scss';

const MobileInfinityData = ({
  isShowLoadingBar = false,
  children,
  data,
  totalRecords,
  customClassName,
  handleCallData,
  itemPerPage = 0,
}) => {
  return (
    <>
      <div
        className={`d-md-none d-flex flex-row flex-wrap ${
          data.length > 0 && totalRecords > itemPerPage && 'infinity-scroll'
        } ${customClassName}`}
        onScroll={(event) => {
          event.target.scrollTop + event.target.clientHeight >=
            event.target.scrollHeight - 10 &&
            data.length < totalRecords &&
            handleCallData();
        }}
      >
        {children}
      </div>
      <div
        className={`d-md-none d-flex glaassmorphism animation-mode flex-row w-100 justify-content-center align-items-center text-dark position-fixed ${
          isShowLoadingBar ? 'show-loading-bar' : 'hide-loading-bar'
        }`}
      >
        <div className="mobileLoader pt-2">
          <li className="ball"></li>
          <li className="ball"></li>
          <li className="ball"></li>
        </div>
        <span className="font-large text-dark">
          <FormattedMessage id="profile.loading" />
        </span>
      </div>
    </>
  );
};

export default MobileInfinityData;
